import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M1392.69971,1700.33236 L1347.91837,1655.55102 L1655.79009,1347.6793 L1700.57143,1392.46064 L1777.81924,1777.58017 L1392.69971,1700.33236 Z M1288.58309,1367.8309 L596.71137,675.959184 L676.198251,596.472303 L1368.06997,1288.34402 L1288.58309,1367.8309 Z M282.122449,589.755102 L128.746356,436.379009 C118.670554,426.303207 111.953353,411.749271 111.953353,397.195335 C111.953353,381.521866 118.670554,368.087464 128.746356,356.892128 L357.131195,128.507289 C368.326531,118.431487 381.760933,111.714286 397.434402,111.714286 C411.988338,111.714286 426.542274,118.431487 436.618076,128.507289 L589.994169,281.883382 L282.122449,589.755102 Z M1803.56851,1337.6035 L747.848397,281.883382 L516.104956,49.0204082 C452.291545,-13.6734694 341.457726,-13.6734694 278.763848,49.0204082 L49.2594752,278.524781 C17.9125364,309.87172 0,352.413994 0,397.195335 C0,441.976676 17.9125364,484.51895 49.2594752,515.865889 L282.122449,747.609329 L1337.84257,1803.32945 L1920,1919.76093 L1803.56851,1337.6035 Z",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1"
});

var IconEditSolid = /*#__PURE__*/function (_Component) {
  _inherits(IconEditSolid, _Component);

  var _super = _createSuper(IconEditSolid);

  function IconEditSolid() {
    _classCallCheck(this, IconEditSolid);

    return _super.apply(this, arguments);
  }

  _createClass(IconEditSolid, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconEdit",
        viewBox: "0 0 1920 1920",
        bidirectional: true
      }), _ref);
    }
  }]);

  IconEditSolid.displayName = "IconEditSolid";
  return IconEditSolid;
}(Component);

IconEditSolid.glyphName = 'edit';
IconEditSolid.variant = 'Solid';
IconEditSolid.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconEditSolid;
export { IconEditSolid };